<script lang="ts">
    export let textColor:string = 'text-hand-purple-500';
</script>
<h1 class="{textColor} flex items-center space-x-4 text-3xl font-bold my-6">
    <slot name="icon" />
    <slot />
</h1>